<template lang="pug">
  field-group
    template(slot='fields')
      .header Добавить диагноз
      select-field(:items='icd', valueProp='id', v-model='diagnosis', filter, hideLabelProp, @searchString='updateDir($event)', :notfiltering='true', :placeholder="'Введите диагноз...'")
        template(slot='label', slot-scope='props')
          span.main {{props.item.code}}
          span.additional {{props.item.name}}
      .additionl_header(v-if='diagnosises.length' )
        .name Код
        .name Наименование
        .name Дата установления *
        .name
      .addintional_text(v-for='(diag, index) in diagnosises', :key='diag.id')
        .value
          .code
            div
              v-icon(name="briefcase-medical" scale="1" style="margin-right: 8px")
              span {{diag.code}}
        .value
          .code {{diag.name || diag.diag_clinical}}
        .value
          .datepicker
            flat-pickr(v-mask="'##.##.####'" title="При ручном вводе данные нужно вводить только через точку" :config="dateConfig" v-model="diag.date" placeholder="дд.мм.гггг"  @blur="onBlur(index)" )
        .value
          .error(v-if="errors && errors[index] && errors[index].date") {{errors[index].date[0]!=="Неправильный формат date. Используйте один из этих форматов: YYYY-MM-DD." ? errors[index].date[0]:""}}
        //-   .error(v-else) {{innerErrors[index]}}
        .value
          .delete
            button(@click='remove(index)') ✖
</template>

<script>
import axios from 'axios'
import SelectField from '@/components/fields/UltraField'
import TextField from '@/components/fields/TextField'
import FieldGroup from '@/components/fields/FieldGroup'
import flatPickr from 'vue-flatpickr-component'
import { Russian } from 'flatpickr/dist/l10n/ru.js'
import 'flatpickr/dist/flatpickr.css'
import Icon from 'vue-awesome/components/Icon'
import { mask } from 'vue-the-mask'

export default {
  components: {
    SelectField,
    TextField,
    FieldGroup,
    flatPickr,
    'v-icon': Icon
  },
  props: ['value', 'errors'],
  data: () => ({
    innerErrors: [],
    icd: [],
    diagnosises: [],
    diagnosis: undefined
  }),
  directives: { mask },
  created () {
    this.diagnosises = this.value ? this.value : []

    axios.get('symptom-checker/api/v1/nsi/directories/sys-icd-entities/?limit=500').then(icd => {
      this.icd = icd.data.results
      this.icd = this.icd.filter(icdentity => icdentity.code !== '')
    })
  },
  methods: {
    onBlur (index) {
      // if (!this.diagnosises[index].date) {
      //   this.$store.dispatch("pushError", this.diagnosises);
      //   this.innerErrors.push("Обязательное поле");
      // } else {
      //   this.$store.dispatch("deleteError", this.diagnosises);
      // }
    },
    remove (index) {
      // this.errors ? this.errors.splice(index, 1) : null;
      // this.innerErrors ? this.innerErrors.splice(index, 1) : null;
      // this.$store.dispatch("deleteError", this.diagnosises);
      this.$store.dispatch('deleteError', 'Дата установления диагноза')
      this.diagnosises.splice(index, 1)
    },
    updateDir (string) {
      if (string.length > 0) {
        axios
          .get(
            'symptom-checker/api/v1/nsi/directories/sys-icd-entities/ultrafield-for-icd/?param__icontains=' +
            string
          )
          .then(icd => {
            this.icd = icd.data.results
            this.icd = this.icd.filter(icdentity => icdentity.code !== '')
          })
      } else {
        axios.get('symptom-checker/api/v1/nsi/directories/sys-icd-entities/?limit=500').then(icd => {
          this.icd = icd.data.results
          this.icd = this.icd.filter(icdentity => icdentity.code !== '')
        })
      }
    }
  },
  watch: {
    diagnosis () {
      if (this.diagnosis) {
        const current = this.icd.filter(diag => this.diagnosis === diag.id)[0]
        this.diagnosises.push({
          icd: this.diagnosis,
          date: current.date,
          name: current.name,
          code: current.code
        })

        this.service = undefined

        this.$emit('input', this.diagnosises)
        this.diagnosis = null
      }
    },
    value () {
      this.diagnosises = this.value ? this.value : []
    }
  },
  updated () {
    if (this.diagnosises.length) {
      for (let key in this.diagnosises) {
        if (this.diagnosises[key].date) {
          let error = 'Дата установления диагноза'
          if (this.diagnosises[key].date.length !== 10) {
            this.$store.dispatch('pushError', error)
          } else {
            this.$store.dispatch('deleteError', error)
          }
        }
      }
    }
  },
  computed: {
    dateConfig () {
      return {
        maxDate: new Date(),
        locale: Russian,
        allowInput: true,
        dateFormat: 'd.m.Y'
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.header
  margin: 10px 0 10px 20px
  font-weight: 450

.additionl_header
  display: grid
  grid-template-columns: 6% 50% 1fr 1fr auto
  column-gap: 30px
  margin: 15px 20px 0 20px
  // border-bottom: 1px solid #ccc
.addintional_text
  display: grid
  column-gap: 30px
  margin: 0 30px 10px 20px
  grid-template-columns: 6% 50%  1fr 1fr auto
.name
  margin-bottom: 15px
  font-weight: 450
.code
  display: grid
  align-content: center
  min-height: 29px
.datepicker
  height: 100%
  padding-left: 5px
.datepicker input
  border-radius: 2px
  height: 29px
  width: 140px
  border: 1px solid #ccc
  font-size: 15px
  color: #212121
  padding-left: 7px
.datepicker input:focus
  border-color: rgba(26, 163, 255, 0.8)
.delete
  display: grid
  justify-content: end
  height: 32px
.delete button
  background: none
  border-radius: 50%
  border: 1px solid #ccc
  width: 34px
  height: 34px
.delete button:hover
  transition: all, .3s
  color: #e2211d
  font-weight: bold
.main
  font-weight: bold
  margin-right: 7px
  font-size: 15px
.additional
  opacity: 0.8
  font-size: 15px
  font-style: italic
.error
  color: #e53935
  min-height: 29px
  font-size: 15px
  display: flex
  align-items: center
@media screen and (max-width: 780px)
  .addintional_text
    padding: 0 0 0 5px
    grid-template-columns: 10% 40%  1fr 0% auto
    column-gap: 1px
  .additionl_header
    padding: 0 0 0 5px
    grid-template-columns: 10% 40%  1fr 0% auto
    column-gap: 1px
</style>
